import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront'
import { EbAnonymousConsentDialogComponent } from '../components/anonymous-consent-dialog/eb-anonymous-consent-dialog.component'

export const defaultEbAnonymousConsentLayoutConfig: LayoutConfig = {
  launch: {
    ANONYMOUS_CONSENT: {
      inline: true,
      component: EbAnonymousConsentDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG
    }
  }
}
